import http from './http'
import createCatalogService from './catalogService'

export default {
  ...createCatalogService('/Telas/EntidadeFinanceira'),
  async getEntityTypeOptions () {
    const response = await http.get('/Telas/EntidadeFinanceira/GetEntityTypeOptions')
    return response.data
  }
}
